import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {CreateTypeContainer, UpdateTypeContainer} from "../../types/api/guide/typeСontainer.types";

export const typeContainerService = {
    getAll: () =>
        apiCall.get(apiUrls.guide.typeContainer.getAll),

    create: (typeContainer: CreateTypeContainer) =>
        apiCall.post(apiUrls.guide.typeContainer.create, typeContainer),

    update: (id: string, typeContainer: UpdateTypeContainer) =>
        apiCall.put(apiUrls.guide.typeContainer.update(id), typeContainer),

    delete: (id: string) =>
        apiCall.delete(apiUrls.guide.typeContainer.delete(id)),

    getById: (id: string) =>
        apiCall.get(apiUrls.guide.typeContainer.getById(id))
}